import { Pipe, PipeTransform } from '@angular/core';
import Decimal from 'decimal.js';

export interface SaldoPlacenoData {
  saldoFakture: {
    cashflow: number;
    finansijskiPromet: number;
  };
}

@Pipe({
  name: 'saldoPlaceno',
})
export class SaldoPlacenoPipe  implements PipeTransform {
  constructor() {}

  transform(value: SaldoPlacenoData, format: 'number' | 'label' = 'label'): string | number {
    try {
      const { saldoFakture } = value;

      const cashflow = new Decimal(saldoFakture?.cashflow || 0);
      const finansijskiPromet = new Decimal(saldoFakture?.finansijskiPromet || 0);

      // Prevent division by zero
      if (finansijskiPromet.isZero()) {
        return format === 'label' ? 'Plaćeno (0.00%)' : 0;
      }

      // Calculate
      const numerator = cashflow;

      if (format === 'number') {
        return numerator.toNumber();
      }

      const percentage = numerator
        .div(finansijskiPromet)
        .times(100)
        .toDecimalPlaces(2);

      return `Plaćeno (${percentage.toFixed(2)}%)`;
    } catch (error) {
      console.error('Error in placenoPercent pipe:', error);
      return format === 'label' ? 'Plaćeno (0.00%)' : 0;
    }


  }
}
